/* eslint-disable import/no-anonymous-default-export */
export default () => {
    /*eslint-disable-next-line no-restricted-globals*/
    self.onmessage = function (e) {
        const { currentData, previousData, channels } = e.data;

        const build = (allData) => {
            // Always return an object even if no data
            if (!allData || allData.length === 0) {
                return {
                    labels: [],
                    datasets: [],
                    headers: channels || [],
                    timeArray: [],
                };
            }

            // Format time for x-axis
            const timeArray = allData.map(p => new Date(p.time));

            // Build headers
            let headers = [];
            if (channels?.length) {
                headers = [...channels];
            } else {
                allData.forEach((d) =>
                    d.data.forEach((el) => {
                        if (!headers.includes(el.Header)) headers.push(el.Header);
                    })
                );
            }

            // Build Chart.js datasets
            const datasets = headers.map((header, idx) => ({
                label: header,
                data: allData.map((p) => {
                    const i = p.data.findIndex((el) => el.Header === header);
                    return i > -1 ? Number(p.data[i].value) : null;
                }),
                borderColor: `hsl(${(idx * 40) % 360}, 70%, 50%)`,
                backgroundColor: `hsl(${(idx * 40) % 360}, 70%, 50%)`,
                borderWidth: 1.5,
                pointRadius: 0,
                fill: false,
            }));

            return {
                labels: timeArray,
                datasets,
                headers,
                timeArray,
            };
        };

        postMessage({
            current: build(currentData),
            previous: build(previousData),
        });
    };
};
